import { useGetEmployeeCompanyIdQuery } from './queries.generated';

export function useIsPayflipCompany(): {
  isPayflipCompany: boolean;
  isLoading: boolean;
} {
  const { data, loading } = useGetEmployeeCompanyIdQuery();
  const payflipIds = [
    '61dd6a3f340a8b0028537d07' // Payflip BV, production.
  ];
  return {
    isPayflipCompany: payflipIds.includes(data?.employee?.company?.id ?? ''),
    isLoading: loading
  };
}
